<div class="container-fluid">

  <div class="row">

    <!-- ================== PTA ================== -->
    <div class="col-sm-12 col-md-6">

      <h4 id="upper">Paramétrage PTA</h4>

   <div class="card shadow-sm">
  <div class="card-body">
    
    <div class="table-responsive">
      <table class="table table-centered table-hover align-middle dt-responsive nowrap w-100">
        <thead class="bg-light-custom">
          <tr>
            <th class="text-center" style="width: 50px;">#</th>
            <th class="fw-bold text-uppercase" style="font-size: 0.85rem;">Année</th>
            <th class="fw-bold text-uppercase" style="font-size: 0.85rem;">Service</th>
            <th class="text-center" style="width: 100px;">Actions</th>
          </tr>
        </thead>
        
        <tbody *ngIf="paginatedProjets.length > 0">
          <tr *ngFor="let item of paginatedProjets; let i = index">
            <td class="text-center text-muted">{{ i + 1 }}</td>
            <td class="fw-bold text-dark">{{ item?.annee }}</td>
            <td>
              <span class="badge bg-soft-info text-info p-2">
                {{ item?.service.libelle }}
              </span>
            </td>
            <td class="text-center">
              <button (click)="confirmDeletionPta(item)" class="btn btn-sm btn-outline-danger border-0">
                <i class="mdi mdi-trash-can font-size-18"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="paginatedProjets.length === 0" class="py-5 text-center">
      <div *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status"></div>
        <h6 class="mt-3 text-muted">Récupération des données...</h6>
      </div>
      
      <div *ngIf="!isLoading">
        <i class="mdi mdi-database-off-outline text-muted" style="font-size: 3rem;"></i>
        <h5 class="mt-2 text-secondary">Aucun projet PTA trouvé</h5>
      </div>
    </div>

    <div class="mt-3 border-top pt-3">
      <p-paginator
        (onPageChange)="onPageChangeProjets($event)"
        [first]="firstProjets"
        [rows]="rowsProjets"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[10,20,30]">
      </p-paginator>
    </div>

  </div>
</div>


    </div>

    <!-- ================== PDC ================== -->
    <div class="col-sm-12 col-md-6">

      <h4 id="upper">Paramétrage PDC</h4>

      <div class="card">
        <div class="card-body">

        <div class="table-responsive mt-3">
  <table class="table table-centered table-hover datatable dt-responsive nowrap w-100">
    <thead class="custom-header">
      <tr>
        <th style="width: 50px;">#</th>
        <th>Année Début</th>
        <th>Année Fin</th>
        <th>Date Adoption</th>
        <th class="text-center">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of paginatedProjetsPdc; let i = index">
        <td>{{ i + 1 }}</td>
        <td class="fw-medium">{{ item?.annee_debut }}</td>
        <td>{{ item?.annee_fin }}</td>
        <td>{{ item?.date_adoption | date:'dd/MM/yyyy' }}</td> <td class="text-center">
          <a (click)="confirmDeletionPdc(item)" class="text-danger action-icon" style="cursor: pointer;">
            <i class="mdi mdi-trash-can font-size-18"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>

          <div *ngIf="paginatedProjetsPdc.length === 0 && isLoadingPdc" class="text-center">
            <h6 id="graycolor">Chargement en cours</h6>
            <div class="loader4"></div>
          </div>

          <div *ngIf="paginatedProjetsPdc.length === 0 && !isLoadingPdc" class="text-center">
            <h5 id="graycolor">Aucune donnée trouvée</h5>
          </div>

          <p-paginator
            (onPageChange)="onPageChangeProjetPdcs($event)"
            [first]="firstProjetsPdc"
            [rows]="rowsProjetsPdc"
            [totalRecords]="totalRecordsPdc"
            [rowsPerPageOptions]="[10,20,30]">
          </p-paginator>

        </div>
      </div>
    </div>

  </div>

</div>

<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
<ngx-ui-loader></ngx-ui-loader>